<template>
    <div class="app-container" id="mainAdmin">
        <div v-if="showLayout" class="admin-panel">
            <!--<header class="header p-3">
                <div class="container-fluid">
                    <div class="row align-items-center">
                        &lt;!&ndash; Logo Section &ndash;&gt;
                        <div class="col-6 col-md-3 d-flex justify-content-start">
                            <div class="logo">
                                <router-link to="/admin/dashboard">
                                    <img src="@/assets/images/Al_Wasiyyat_Logo_H.png" alt="WASIYYAH" class="img-fluid">
                                </router-link>
                            </div>
                        </div>

                        &lt;!&ndash; Toggle Button for Mobile &ndash;&gt;
                        <div class="col-6 d-md-none d-flex justify-content-end">
                            <button @click="toggleSidebar" class="toggle-button">
                                <font-awesome-icon :icon="['fas', 'bars']"/>
                            </button>
                        </div>

                        &lt;!&ndash; Language Selector and Profile Section &ndash;&gt;
                        <div class="col-6 col-md-9 d-none d-md-flex justify-content-end align-items-center gap-3">
                            &lt;!&ndash; Language Selector &ndash;&gt;
                            <div class="d-flex align-items-center gap-2">
                                &lt;!&ndash;<div class="alertDropdown" ref="alertDropdown">
                                    <div class="profile-logo d-flex align-items-center" @click="toggleNotifyDropdown">
                                        <font-awesome-icon class="text-dark" :icon="['fas', 'bell']"/>
                                        &lt;!&ndash; Green Dot for Unread Notifications &ndash;&gt;
                                        <span v-if="unreadCount > 0" class="notification-dot"></span>
                                    </div>

                                    <ul class="alertDropdown-menu" :class="{ show: showAlertDropdown }"
                                        :style="notificationData.length > 3 ? 'max-height: 550px; overflow-y: auto;' : ''">
                                        <li class="d-flex justify-content-between align-items-center px-3 py-2 border-bottom font-monospace"
                                            style="font-size: 12px">
                                            <span class="heading text-primary cursor-pointer m-auto">MARK ALL AS READ!</span>
                                        </li>
                                        <li v-for="(notification, index) in notificationData" :key="index">
                                            <div v-html="notification.message"></div>
                                            &lt;!&ndash;                                            {{notification.requestKey}}&ndash;&gt;
                                            <span v-if="containsHtml(notification.message)">
                                                <a @click="approved('Y', notification)" class="btn btn-success btn-sm"
                                                   style="background-color:#39B048;color:white;border:none;padding:5px 20px;border-radius:5px;margin-right: 5px;">Approve</a>
                                                <a @click="decline('N', notification)" class="btn btn-danger btn-sm">Decline</a>
                                            </span>
                                        </li>
                                    </ul>
                                </div>&ndash;&gt;

                                <div class="alertDropdown" ref="alertDropdown">
                                    <div class="profile-logo d-flex align-items-center" @click="toggleNotifyDropdown">
                                        <font-awesome-icon class="text-dark" :icon="['fas', 'bell']" />
                                        &lt;!&ndash; Green Dot for Unread Notifications &ndash;&gt;
                                        <span v-if="unreadCount > 0" class="notification-dot"></span>
                                    </div>

                                    <ul
                                            class="alertDropdown-menu"
                                            :class="{ show: showAlertDropdown }"
                                            :style="notificationData.length > 3 ? 'max-height: 550px; overflow-y: auto;' : ''"
                                    >
                                        <li
                                                class="d-flex justify-content-between align-items-center px-3 py-2 border-bottom font-monospace"
                                                style="font-size: 12px"
                                        >
                                            <span class="heading text-primary cursor-pointer m-auto">MARK ALL AS READ!</span>
                                        </li>
                                        <li v-for="(notification, index) in notificationData" :key="index">
                                            <div v-html="notification.message"></div>
                                            <span v-if="containsHtml(notification.message)">
                                                <a
                                                        @click="approved('Y', notification)"
                                                        class="btn btn-success btn-sm"
                                                        style="background-color: #39b048; color: white; border: none; padding: 5px 20px; border-radius: 5px; margin-right: 5px;"
                                                >
                                                  Approve
                                                </a>
                                                <a @click="decline('N', notification)" class="btn btn-danger btn-sm">Decline</a>
                                              </span>
                                        </li>
                                    </ul>
                                </div>


                                &nbsp;
                                <font-awesome-icon :icon="['fas', 'globe']"/>
                                <b-form-select
                                        style="background: #d1e3e6; padding: 10px !important;"
                                        class="border rounded-2"
                                        v-model="lang"
                                        :options="langOptions"
                                        field-text="filter.text"
                                        field-value="filter.value"
                                        :reduce="option => option.value"
                                ></b-form-select>
                            </div>

                            &lt;!&ndash; Profile Dropdown &ndash;&gt;
                            <div class="dropdown" ref="dropdown">
                                <div class="profile-logo d-flex align-items-center" @click="toggleDropdown">
                                    <img
                                            v-if="profilePictureUrl"
                                            :src="profilePictureUrl"
                                            alt="Profile"
                                            class="rounded-circle me-2"
                                            style="width: 40px; height: 40px"
                                    />
                                    <img
                                            v-else
                                            src="@/assets/images/profile.jpg"
                                            alt="Profile"
                                            class="rounded-circle me-2"
                                            style="width: 40px; height: 40px"
                                    />
                                    <span class="d-none d-md-inline">{{allUserData.firstName + " " + allUserData.lastName}}</span>
                                </div>
                                <ul class="dropdown-menu" :class="{ show: showDropdown }">
                                    <li>
                                        <router-link class="dropdown-item" to="/admin/profile">Profile</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/admin/password-change">Change Password
                                        </router-link>
                                    </li>
                                    <li><a @click="logout" class="dropdown-item cursor-pointer">Logout</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </header>-->
            <header class="header p-3">
                <div class="container-fluid">
                    <div class="row align-items-center">
                        <!-- Logo Section -->
                        <div class="col-6 col-md-3 d-flex justify-content-start">
                            <div class="logo">
                                <router-link to="/admin/dashboard">
                                    <img src="@/assets/images/Al_Wasiyyat_LogoN.png" alt="WASIYYAH" class="img-fluid">
                                </router-link>
                            </div>
                        </div>

                        <!-- ✅ MOBILE ONLY: Language Selector (Globe triggers dropdown) -->
                        <div class="col-4 d-flex d-md-none justify-content-end">
                            <b-form-select
                                    ref="langSelect"
                                    style="background: #d1e3e6; padding: 10px !important;"
                                    class="border rounded-2 w-50 pointer-events-none"
                                    v-model="lang"
                                    :options="langOptions"
                                    field-text="filter.text"
                                    field-value="filter.value"
                                    :reduce="option => option.value"
                            ></b-form-select>
                        </div>


                        <!-- Toggle Button for Mobile -->
                        <div class="col-2 d-md-none d-flex justify-content-end">
                            <button @click="toggleSidebar" class="toggle-button">
                                <font-awesome-icon :icon="['fas', 'bars']"/>
                            </button>
                        </div>

                        <!-- DESKTOP: Notification + Language + Profile -->
                        <div class="col-6 col-md-9 d-none d-md-flex justify-content-end align-items-center gap-3">
                            <!-- Notification Dropdown -->
                            <div class="alertDropdown" ref="alertDropdown">
                                <div class="profile-logo d-flex align-items-center" @click="toggleNotifyDropdown">
                                    <font-awesome-icon class="text-dark" :icon="['fas', 'bell']"/>
                                    <span v-if="unreadCount > 0" class="notification-dot"></span>
                                </div>
                                <ul class="alertDropdown-menu" :class="{ show: showAlertDropdown }"
                                    :style="notificationData.length > 3 ? 'max-height: 550px; overflow-y: auto;' : ''">
                                    <li class="d-flex justify-content-between align-items-center px-3 py-2 border-bottom font-monospace"
                                        style="font-size: 12px">
                                        <span class="heading text-primary cursor-pointer m-auto">MARK ALL AS READ!</span>
                                    </li>
                                    <li v-for="(notification, index) in notificationData" :key="index">
                                        <div v-html="notification.message"></div>
                                        <span v-if="containsHtml(notification.message)">
                                            <a @click="approved('Y', notification)" class="btn btn-success btn-sm"
                                               style="background-color:#39B048;color:white;border:none;padding:5px 20px;border-radius:5px;margin-right: 5px;">Approve</a>
                                            <a @click="decline('N', notification)"
                                               class="btn btn-danger btn-sm">Decline</a>
                                        </span>
                                    </li>
                                </ul>
                            </div>

                            <!-- Language Dropdown -->
                            <div class="d-flex align-items-center gap-2">
                                <font-awesome-icon :icon="['fas', 'globe']"/>
                                <b-form-select
                                        style="background: #d1e3e6; padding: 10px !important;"
                                        class="border rounded-2"
                                        v-model="lang"
                                        :options="langOptions"
                                        field-text="filter.text"
                                        field-value="filter.value"
                                        :reduce="option => option.value"
                                ></b-form-select>
                            </div>

                            <!-- Profile Dropdown -->
                            <div class="dropdown" ref="dropdown">
                                <div class="profile-logo d-flex align-items-center" @click="toggleDropdown">
                                    <img v-if="profilePictureUrl" :src="profilePictureUrl" alt="Profile"
                                         class="rounded-circle me-2" style="width: 40px; height: 40px"/>
                                    <img v-else src="@/assets/images/profile.jpg" alt="Profile"
                                         class="rounded-circle me-2" style="width: 40px; height: 40px"/>
                                    <span class="d-none d-md-inline">{{ allUserData.firstName + " " + allUserData.lastName }}</span>
                                </div>
                                <ul class="dropdown-menu" :class="{ show: showDropdown }">
                                    <li>
                                        <router-link class="dropdown-item" to="/admin/profile">Profile</router-link>
                                    </li>
                                    <li>
                                        <router-link class="dropdown-item" to="/admin/password-change">Change Password
                                        </router-link>
                                    </li>
                                    <li><a @click="logout" class="dropdown-item cursor-pointer">Logout</a></li>
                                </ul>
                            </div>
                        </div>


                    </div>
                </div>
            </header>

            <!-- Sidebar -->
            <nav class="sidebar rounded-bottom-5"
                 :class="{ 'sidebar-visible': isSidebarVisible, 'sidebar-hidden': !isSidebarVisible }">

                <!--            <nav class="sidebar rounded-bottom-5" :class="{ 'sidebar-visible': isSidebarVisible }">-->
                <ul>
                    <!-- <li>
                        <router-link to="/admin/dashboard">{{$t("Dashboard")}}</router-link>
                    </li>
                    
                    <li>
                        <router-link to="/admin/profile">{{$t("Profile")}}</router-link>
                    </li>
                    <li>
                        <router-link to="/admin/create-wasiyyah">{{$t("Create Wasiyyah")}}</router-link>
                    </li> -->

                    <router-link to="/admin/dashboard" custom v-slot="{ navigate }">
                        <li class="text-white" @click="navigate">{{ $t("Dashboard") }}</li>
                    </router-link>
                    <router-link to="/admin/profile" custom v-slot="{ navigate }">
                        <li class="text-white" @click="navigate">{{ $t("Profile") }}</li>
                    </router-link>
                    <router-link to="/admin/create-wasiyyah" custom v-slot="{ navigate }">
                        <li class="text-white" @click="navigate">{{ $t("Create Wasiyyah") }}</li>
                    </router-link>
                    
                    <li v-if="isAdmin" class="mb-2">
                        <div class="dropdown-container">
                            <div @click="toggleMenu('admin')" class="align-items-center cursor-pointer text-white">
                                {{$t("Admin")}}
                                <span class="ms-5 text-white">
                                    <font-awesome-icon
                                            :icon="activeMenuIndex === 'admin' ? 'caret-down' : 'caret-right'"/>
                                </span>
                            </div>

                            <div v-show="activeMenuIndex === 'admin'" class="submenu-container">
                                <router-link to="/admin/branch-add" class="submenu-link">{{$t("Branch Add")}}
                                </router-link>
                                <router-link to="/admin/blog-post" class="submenu-link">{{$t("Blog Post")}}
                                </router-link>
                                <router-link to="/admin/ip-allowed" class="submenu-link">{{$t("IP Allowed")}}
                                </router-link>
                                <router-link to="/admin/nisab-insert" class="submenu-link">{{$t("Nisab Amount Update")}}
                                </router-link>

                            </div>
                        </div>
                    </li>

                    <!-- <li>
                        <router-link to="/admin/sub-menu-create">{{$t("Access Control")}}</router-link>
                    </li> -->

                    <router-link to="/admin/sub-menu-create" custom v-slot="{ navigate }">
                        <li class="text-white" @click="navigate">{{ $t("Access Control") }}</li>
                    </router-link>

                    <!-- <li>-->
                    <!-- <router-link to="/admin/nisab-insert">Nisab Amount Update</router-link>-->
                    <!-- </li>-->
                    <li v-for="(menu, index) in menus" :key="menu.menuId" class="mb-2">
                        <div class="dropdown-container">
                            <a @click.prevent="toggleMenu(index)"
                               class="">
                                <!--                                {{ menu.menuName }}-->
                                <span v-if="menu.menuName === 'Nominee Panel'">{{ $t('Nominee Panel') }}</span>
                                <span v-else>{{ $t('Witness Panel') }}</span>
                                <span class="ms-2">
                                    <font-awesome-icon
                                            :icon="activeMenuIndex === index ? 'caret-down' : 'caret-right'"/>
                                </span>
                            </a>

                            <div v-show="activeMenuIndex === index" class="submenu-container">
                                <router-link
                                        v-for="submenu in menu.subMenus"
                                        :key="submenu.submenuId"
                                        class="submenu-link"
                                        :to="{ name: menu.basePath.replace('/', ''), params: { id: submenu.submenuId } }"

                                >
                                    <!--                                        :to="`${menu.basePath}/${submenu.submenuId}`"-->
                                    <!--:to="{ name: 'nominee-panel', params: { id: submenu.submenuId } }"-->
                                    {{ submenu.submenuName }}
                                </router-link>
                            </div>
                        </div>
                    </li>

                
                    <!-- <li>
                        <router-link to="/admin/calc">{{$t("Calculation")}}</router-link>
                    </li>
                    <li>
                        <router-link to="/admin/calc-zakat">{{$t("Zakat Calculation")}}</router-link>
                    </li>
                    <li>
                        <router-link to="/admin/witness">{{$t("Witness")}}</router-link>
                    </li>
                    <li>
                        <router-link to="/admin/nominee">{{$t("Nominee")}}</router-link>
                    </li> -->
                    
                    <router-link to="/admin/calc" custom v-slot="{ navigate }">
                        <li class="text-white" @click="navigate">{{ $t("Calculation") }}</li>
                    </router-link>
                    <router-link to="/admin/calc-zakat" custom v-slot="{ navigate }">
                        <li class="text-white" @click="navigate">{{ $t("Zakat Calculation") }}</li>
                    </router-link>
                    <router-link to="/admin/witness" custom v-slot="{ navigate }">
                        <li class="text-white" @click="navigate">{{ $t("Witness") }}</li>
                    </router-link>
                    <router-link to="/admin/nominee" custom v-slot="{ navigate }">
                        <li class="text-white" @click="navigate">{{ $t("Nominee") }}</li>
                    </router-link>
                </ul>
            </nav>


            <!-- Main Content -->
            <main class="admin-content" :class="{ 'content-full': !isSidebarVisible }">
                <router-view/>
            </main>

            <!-- Footer -->
            <footer class="admin-footer">
                <p>&copy; 2025 Your Company</p>
            </footer>
        </div>
        <div v-else>
            <router-view/>
        </div>
    </div>
</template>
<script>
    // import Header from "@/components/layouts/partials/Header.vue";
    // import Sidebar from "@/components/layouts/partials/Sidebar.vue";
    // import Footer from "@/components/layouts/partials/Footer.vue";

    import apiRepository, {getImage} from "@/services/ApiRepository";
    import {toast} from "vue3-toastify";
    import {mapActions, mapGetters} from "vuex";


    export default {
        data() {
            const savedLang = localStorage.getItem("locale") || 'en';
            return {
                profilePictureUrl: null,
                isSidebarVisible: window.innerWidth > 767.98,
                notificationData: [],
                menus: [],
                showDropdown: false,
                showAlertDropdown: false,
                allUserData: [],
                langOptions: [
                    {text: "EN", value: "en"},
                    {text: "BN", value: "bn"},
                ],
                lang: savedLang,
                activeMenuIndex: null,
                getTraceData: null,
            };
        },
        computed: {
            showLayout() {
                const noLayoutRoutes = ["/login", "/sign-up"];
                return !noLayoutRoutes.includes(this.$route.path);
            },
            unreadCount() {
                return this.notificationData.filter(n => n.status === 'UNREAD').length;
            },
            ...mapGetters(['isTestator', 'isAdmin', 'currentLang']),
        },
        mounted() {
            window.addEventListener("resize", this.handleResize);
            document.addEventListener("click", this.closeDropdownOnClickOutside);
            document.addEventListener("click", this.closeNotifyDropdown);
            this.handleResize();
            this.getNotificationData();
            this.getUserData();
            this.getMenusData();
            if (this.$i18n) {
                this.$i18n.locale = this.lang;
            }
        },
        created() {
            this.decodeToken();
            this.$i18n.locale = this.lang;
        },
        beforeUnmount() {
            document.removeEventListener("click", this.closeDropdownOnClickOutside);
            document.removeEventListener("click", this.closeNotifyDropdown);
            window.removeEventListener("resize", this.handleResize);
        },
        watch: {
            lang(newLang) {
                if (newLang) {
                    this.$i18n.locale = newLang;
                    localStorage.setItem("locale", newLang);
                    window.location.reload();
                }
            }
        },
        methods: {
            ...mapActions(["decodeToken"]),
            containsHtml(message) {
                return /<b>.*<\/b>\s*selected you as\s*a witness\s*<br>/i.test(message); // Checks if message contains any HTML tags
            },
            approved(status, notification) {
                const payload = {
                    requestKey: notification.requestKey, // Extract requestKey from notification
                    status: status,
                };
                this.sendApproval(payload);
            },
            decline(status, notification) {
                const payload = {
                    requestKey: notification.requestKey, // Extract requestKey from notification
                    status: status,
                };
                this.sendApproval(payload);
            },
            sendApproval(payload) {
                apiRepository.acceptRejectRequest(payload).then((response) => {
                    if (response) {
                        toast.success(response.data);
                        this.getNotificationData();
                    }
                })
            },
            handleResize() {
                this.isSidebarVisible = window.innerWidth > 767.98;
            },


            toggleSidebar() {
                this.isSidebarVisible = !this.isSidebarVisible;
            },
            toggleDropdown() {
                this.showDropdown = !this.showDropdown;
            },
            toggleNotifyDropdown() {
                this.showAlertDropdown = !this.showAlertDropdown;
            },

            closeDropdownOnClickOutside(event) {
                if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
                    this.showDropdown = false;
                }
            },
            closeNotifyDropdown(event) {
                if (this.$refs.alertDropdown && !this.$refs.alertDropdown.contains(event.target)) {
                    this.showAlertDropdown = false;
                }
            },

            logout() {
                localStorage.removeItem("authToken");
                this.$router.push({name: "Login"});
            },
            getUserData() {
                try {
                    apiRepository.userDataGet().then((res) => {
                        if (res) {
                            this.allUserData = res.data.userProfile;
                            this.profilePictureUrl = getImage() + this.allUserData.profilePictureUrl;
                        }
                    }).catch((error) => {
                        console.log(error.response?.data);
                    })
                } catch (e) {
                    console.error("Invalid Request!", e);
                }
            },
            getNotificationData() {
                try {
                    apiRepository.getNotifications().then((res) => {
                        if (res) {
                            this.notificationData = res.data
                        }
                    }).catch((error) => {
                        console.log(error.response?.data);
                    })
                } catch (e) {
                    console.log(e)
                }

            },
            getMenusData() {
                apiRepository.getMenus().then((res) => {
                    if (res) {
                        this.menus = res.data;
                    }
                }).catch((error) => {
                    console.log(error.response?.data);
                })
            },
            toggleMenu(index) {
                this.activeMenuIndex = this.activeMenuIndex === index ? null : index;
            },
        },

    };

</script>

<style scoped>
    /* Existing styles... */
    .sidebar {
        width: 260px;
        background: linear-gradient(90deg, rgba(226, 234, 221, 1) 0%, rgba(190, 192, 216, 1) 82%, rgba(219, 219, 219, 1) 100%);
        padding: 25px 0;
        overflow-y: auto;
        position: absolute;
        top: 51px !important; /* Positioned below the header */
        left: 17px !important;
        height: calc(100% - 60px); /* Full height minus the header */
        border-right: 2px solid white;
        /*border-radius: 0 20px 20px 0;*/
        z-index: 1000;
        margin-bottom: 400px;

    }

    .sidebar ul {
        list-style: none;

    }

    .sidebar li {
        width: 220px;
        height: 50px;
        margin: 10px auto;
        padding: 10px;
        border-radius: 10px;
        text-align: center;
        background: linear-gradient(135deg, #5e9a98, #0e5f57);
        border: 1px solid white;
    }

    .sidebar li:hover {
        background: rgba(255, 255, 255, 0.2);
        border: 1px solid #077747;
        cursor: pointer;
    }

    .sidebar a {
        text-decoration: none;
        color: white;
        font-size: 16px;
    }

    .admin-content {
        flex: 1;
        padding: 40px;
        margin-left: 260px; /* Adjusted for sidebar width */
        background: linear-gradient(90deg, rgba(226, 234, 221, 1) 0%, rgba(190, 192, 216, 1) 82%, rgba(219, 219, 219, 1) 100%);
        overflow-y: auto;
        border-left: 2px solid white;
    }

    .admin-footer {
        background-color: #d1e4e6;
        padding: 0.5rem 0.5rem;
        text-align: center;
        border-top: 2px solid white;
        border-radius: 0 0 20px 20px;
        z-index: 1001;
    }


    /* Sidebar Styles */
    .sidebar {
        width: 260px;
        background: linear-gradient(90deg, rgba(226, 234, 221, 1) 0%, rgba(190, 192, 216, 1) 82%, rgba(219, 219, 219, 1) 100%);
        padding: 25px 0;
        overflow-y: auto;
        /*position: fixed;*/
        top: 60px; /* Positioned below the header */
        bottom: 50px;
        left: 23px; /* Visible by default */
        height: calc(100% - 90px); /* Full height minus the header */
        border-right: 2px solid white;
        transition: left 0.3s ease;
        z-index: 1000;
    }

    .sidebar-hidden {
        left: -300px !important; /* Hide off-screen */
        transition: left 0.3s ease;
    }

    @media (min-width: 768px) {
        .admin-content.content-full {
            margin-left: 0 !important;
        }
    }

    .admin-content.content-full {
        margin-left: 0 !important;
    }

    /* Hide sidebar on small screens by default */
    /*@media (max-width: 767.98px) {
        .sidebar {
            left: -260px; !* Hide sidebar by default *!
            margin-bottom: 50px;
        }

        .sidebar-visible {
            left: 23px; !* Show sidebar when toggled *!
        }
    }*/

    /* Adjust main content when sidebar is hidden */
    .content-full {
        margin-left: 0;
    }

    /* Toggle Button for Mobile */
    .toggle-button {
        background: none;
        border: none;
        font-size: 24px;
        cursor: pointer;
        display: none; /* Hide toggle button by default */
    }

    /* Show toggle button only on small screens */
    @media (max-width: 767.98px) {
        .toggle-button {
            display: block; /* Show toggle button */
        }
    }

    .admin-footer {
        margin-bottom: 0;
        /*  position: fixed;*/
    }

    .cursor-pointer {
        cursor: pointer;
    }

    /*Notification Modal*/
    /* Dropdown container */

    /*.alertDropdown {
        position: relative;
        display: inline-block;
        background-color: #f8f9fa;
        border-radius: 8px;
        padding: 10px 15px;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    }

    .alertDropdown:hover {
        background-color: #e2e6ea;
    }

    !* Dropdown Menu Styling *!
    .alertDropdown-menu {
        list-style: none;
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translate(-50%, 10px); !* center and offset downward *!
        background: white;
        width: 280px;
        height: 300px;
        border-radius: 10px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
        padding: 10px;
        opacity: 0;
        transition: opacity 0.3s ease, transform 0.3s ease;
        z-index: 1000;
    }

    !* Show Dropdown *!
    .alertDropdown-menu.show {
        opacity: 1;
        transform: translate(-50%, 0); !* bring up into place *!
    }

    !* Dropdown Items *!
    .alertDropdown-menu li {
        border-radius: 5px;
        padding: 10px;
        border-bottom: 1px solid #ddd;
        cursor: pointer;
        transition: background 0.2s ease-in-out;
        background: #e3e3e3;
        color: #000000;
    }

    .alertDropdown-menu li:last-child {
        border-bottom: none;
    }

    .alertDropdown-menu li:hover {
        color: #000000;
    }*/

    .alertDropdown {
        position: relative;
        display: inline-block;
        background-color: #f8f9fa;
        border-radius: 8px;
        padding: 10px 15px;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    }

    .alertDropdown:hover {
        background-color: #e2e6ea;
    }

    .alertDropdown-menu {
        list-style: none;
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translate(-50%, 10px);
        background: white;
        width: 280px;
        height: 300px;
        border-radius: 10px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
        padding: 10px;
        opacity: 0;
        pointer-events: none; /* 👈 prevent interaction when hidden */
        z-index: -1; /* 👈 prevent UI overlap when hidden */
        transition: opacity 0.3s ease, transform 0.3s ease;
    }

    /* Show Dropdown */
    .alertDropdown-menu.show {
        opacity: 1;
        transform: translate(-50%, 0);
        pointer-events: auto; /* 👈 allow interaction when shown */
        z-index: 1000; /* 👈 ensure it's above other content */
    }

    /* Dropdown Items */
    .alertDropdown-menu li {
        border-radius: 5px;
        padding: 10px;
        border-bottom: 1px solid #ddd;
        cursor: pointer;
        transition: background 0.2s ease-in-out;
        background: #e3e3e3;
        color: #000000;
    }

    .alertDropdown-menu li:last-child {
        border-bottom: none;
    }

    .alertDropdown-menu li:hover {
        color: #000000;
    }

    /*.alertDropdown {
        !*position: relative;*!
        !*display: inline-block;*!
        background-color: #f8f9fa;
        border-radius: 8px;
        padding: 10px 15px;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
        !*transition: all 0.3s ease-in-out;*!
    }

    .alertDropdown:hover {
        background-color: #e2e6ea;
        display: inline-block
        !*transform: scale(1.05);*!
    }

    .alertDropdown-menu {
        list-style: none;
        position: absolute;
        top: 40px;
        right: 0;
        background: white;
        width: 280px;
        height: 300px;
        border-radius: 10px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
        padding: 10px;
        opacity: 0;
        transform: translateY(-10px);
        transition: opacity 0.3s ease, transform 0.3s ease;
        z-index: 1000;
    }

    .alertDropdown-menu.show {
        opacity: 1;
        transform: translateY(0);
    }

    .alertDropdown-menu li {
        border-radius: 5px;
        padding: 10px;
        border-bottom: 1px solid #ddd;
        cursor: pointer;
        transition: background 0.2s ease-in-out;
        background: #e3e3e3;
        color: #000000;
    }

    .alertDropdown-menu li:last-child {
        border-bottom: none;
    }

    .alertDropdown-menu li:hover {
        color: #000000;
    }*/

    /* 🔔 Bell Icon Container */
    .profile-logo {
        position: relative;
        cursor: pointer;
    }

    /* 🟢 Notification Dot */
    .notification-dot {
        position: absolute;
        top: -5px;
        right: -10px;
        width: 8px;
        height: 8px;
        background: #efd708;
        border-radius: 50%;
    }


    /*submenu style*/

    .submenu-container {
        position: absolute;
        background: linear-gradient(90deg, rgba(226, 234, 221, 1) 0%, rgba(190, 192, 216, 1) 82%, rgba(219, 219, 219, 1) 100%);
        border-radius: 10px;
        padding: 10px;
        z-index: 10;
        min-width: 220px;
        margin-top: 10px;

        /* 💎 Improved shadow */
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.6);
        border: 1px solid #ccc;
        transition: all 0.3s ease-in-out;
    }

    .submenu-link {
        display: block;
        padding: 10px 15px;
        margin-bottom: 8px;
        text-align: center;
        color: white;
        background: linear-gradient(135deg, #5e9a98, #0e5f57);
        border-radius: 8px;
        text-decoration: none;
        font-weight: 500;
        transition: all 0.3s ease-in-out;
    }

    /* ✅ Fixing hover visibility */
    .submenu-link:hover {
        background: #ffffff;
        color: #0e5f57;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    }

</style>




